__turbopack_context__.v({
  "bestPractices": "p2g9pa_bestPractices",
  "bestPracticesTitle": "p2g9pa_bestPracticesTitle",
  "checkbox": "p2g9pa_checkbox",
  "checkboxLabel": "p2g9pa_checkboxLabel",
  "checkboxText": "p2g9pa_checkboxText",
  "checkboxWrapper": "p2g9pa_checkboxWrapper",
  "closeButton": "p2g9pa_closeButton",
  "content": "p2g9pa_content",
  "continueButton": "p2g9pa_continueButton",
  "description": "p2g9pa_description",
  "dialog": "p2g9pa_dialog",
  "footer": "p2g9pa_footer",
  "iconWrapper": "p2g9pa_iconWrapper",
  "overlay": "p2g9pa_overlay",
  "practiceContent": "p2g9pa_practiceContent",
  "practiceIcon": "p2g9pa_practiceIcon",
  "practiceItem": "p2g9pa_practiceItem",
  "practiceText": "p2g9pa_practiceText",
  "practiceTitle": "p2g9pa_practiceTitle",
  "title": "p2g9pa_title",
});
